export const UPDATE_USER = 'auth/update_user'
